// extracted by mini-css-extract-plugin
export default {"articleSummary":"articleSummary__ARFen","summaryHeading":"summaryHeading__6M1tT"};